import { useEffect, useRef, useState } from "react";
import { getImageDimensionsFromUrl } from "./getImageDimensionsFromFile";

const aspectByUrl = new Map();

const loadAspect = async (url) => {
  if (aspectByUrl.has(url)) return aspectByUrl.get(url);
  try {
    const dimensions = await getImageDimensionsFromUrl({ url });
    const width = Number(dimensions?.width) || 0;
    const height = Number(dimensions?.height) || 0;
    if (width > 0 && height > 0) {
      const aspect = width / height;
      aspectByUrl.set(url, aspect);
      return aspect;
    }
  } catch {
    // Fail open: the phrase stays as text until the image can be measured.
  }
  aspectByUrl.set(url, null);
  return null;
};

const urlsKey = (urls) =>
  Object.entries(urls || {})
    .filter(([assetRef, url]) => assetRef && String(url || "").trim())
    .map(([assetRef, url]) => `${assetRef}:${url}`)
    .sort()
    .join("|");

export const useInlineReplacementMetrics = ({ urls = {} } = {}) => {
  const urlKey = urlsKey(urls);
  const urlsRef = useRef(urls);
  urlsRef.current = urls;
  const [metrics, setMetrics] = useState({});

  useEffect(() => {
    let cancelled = false;
    const entries = Object.entries(urlsRef.current || {}).filter(
      ([assetRef, url]) => assetRef && String(url || "").trim()
    );
    if (!entries.length) {
      setMetrics((current) =>
        Object.keys(current).length ? {} : current
      );
      return undefined;
    }
    const load = async () => {
      const next = {};
      await Promise.all(
        entries.map(async ([assetRef, url]) => {
          const aspect = await loadAspect(url);
          if (Number.isFinite(aspect) && aspect > 0) {
            next[assetRef] = { aspect };
          }
        })
      );
      if (!cancelled) setMetrics(next);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [urlKey]);

  return metrics;
};
